import React from 'react'

import { BulletinType } from '../../../../../common/validations'
import { AttachmentLink } from './components/AttachmentLink/AttachmentLink'
import { AttachmentLinkErrorHandler } from './components/AttachmentLink/AttachmentLinkErrorHandler'

interface BulletinAttachmentsProps {
  attachments: BulletinType['attachments']
}

export const BulletinAttachments: React.FC<BulletinAttachmentsProps> = ({
  attachments,
}) => {
  if (!attachments) {
    return null
  }

  return (
    <div className="flex flex-col justify-start space-y-2 mt-10 w-full">
      {attachments.map((attachment) => (
        <AttachmentLinkErrorHandler key={attachment.uuid}>
          <AttachmentLink attachment={attachment} />
        </AttachmentLinkErrorHandler>
      ))}
    </div>
  )
}
